import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./styles/App.css";
import HomePage from "./HomePage";
import SanitizedForm from "./SanitizedForm";
import SpeakerSearch from "./SpeakerSearch";

const PageLayout: React.FC<{
    title: string;
    subtitle: string;
    children: any;
}> = ({ title, subtitle, children }) => (
    <div>
        {/* Hero Banner */}
        <div className="hero-banner">
            <div className="hero-content">
                <h1 className="hero-title">{title}</h1>
                <p className="hero-subtitle">{subtitle}</p>
            </div>
        </div>
        {/* Page Content */}
        <div className="page-content">{children}</div>
    </div>
);

const About = () => (
    <PageLayout title="About Us" subtitle="Learn more about the group.">
        <p>
            The 5th Tradition Group began as a small group of AA members seeking
            to Carry the AA Message and create the kind of fellowship they
            craved. The Group began organizing in November 2008 in one of our
            founding member’s homes. Early discussions evolved into a set of
            core ideals on which the Group came to be based: a strong focus on
            the program of action detailed in the Big Book, the importance of
            the Home Group to long term sobriety and AA Unity, adherence to AA’s
            12 Traditions, the importance of Sponsorship and 12 step work, and
            the conviction that sobriety should be filled with joy and
            enthusiasm! <br />
            <br />
            There followed several challenging months when no good location
            could be found for the new Group. Then, almost magically, everything
            fell into place, including the perfect location, at the perfect size
            with room to grow. The 5th Tradition Group’s first official meeting
            was held on Saturday May 15th 2009 at 7:00 PM. <br /> <br /> Since
            that time, the Group has grown into an active and enthusiastic one.
            We hold a Closed Big Book Study on Thursday nights at 7pm, and an
            Open Speaker Meeting on Saturdays at 7pm - both at Embry Hills
            United Methodist Church in Chamblee. There is also an Al-Anon Group
            meeting at the Church on Thursdays at 7pm. In addition, we carry two
            meetings into local treatment centers: Atlanta Recovery Place on
            Monday nights at 7:30, and Samba Recovery on Friday nights at 7:00.
            We also take commitments into correctional facilities, DUI schools
            and local educational facilities. We would love to see you, so
            please drop in on us anytime. We promise you will be greeted at the
            door and welcomed into the Fellowship of AA.
            <br /> <br />
            In Love and Service, <br />
            <br />
            5th Tradition Group
        </p>
    </PageLayout>
);

const Events = () => (
    <PageLayout title="Events" subtitle="Find out more about upcoming events.">
        <div className="calendar-wrapper" style={{ justifyContent: "center" }}>
            <h1 className="hero-title" style={{ marginBottom: "5rem" }}>
                <iframe
                    className="calendar-desktop"
                    title="Events calendar"
                    src="https://calendar.google.com/calendar/embed?src=ftgpoobah%40gmail.com&ctz=America%2FNew_York&mode=AGENDA&showTitle=0&showPrint=0&showTabs=1&showCalendars=0&showTz=0"
                    loading="eager"
                />
            </h1>
        </div>
    </PageLayout>
);

const SoundCloudPlayer = ({ url }: any) => {
    // const playlistUrl = "https://api.soundcloud.com/playlists/YOUR_PLAYLIST_ID"; // Replace with your private playlist ID
    // const embedUrl = `https://w.soundcloud.com/player/?url=${encodeURIComponent(
    //     playlistUrl
    // )}&color=%23ff5500`;
    return (
        <iframe
            width="100%"
            height="450"
            scrolling="no"
            frameBorder="no"
            allow="autoplay"
            src={url}
        ></iframe>
    );
};

const Speakers = () => (
    <PageLayout
        title="Recent Speakers"
        subtitle="Listen to all of our recent speakers."
    >
        <SoundCloudPlayer url="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%3Aplaylists%3A2175050717%3Fsecret_token%3Ds-slJcMSlbuYU&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=true&visual=false" />
    </PageLayout>
);

const SpeakersArchived = () => (
    <PageLayout
        title="Archived Speakers"
        subtitle="Listen to all of our archived speakers."
    >
        <SoundCloudPlayer url="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2050631808%3Fsecret_token%3Ds-jY9dQJ8kPS7&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=true&visual=false" />
        <div style={{ marginTop: "2rem" }}></div>
        <SoundCloudPlayer url="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2050630953%3Fsecret_token%3Ds-6vPadWg0AI8&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=true&visual=false" />
    </PageLayout>
);

const SpeakersWorkshop = () => (
    <PageLayout
        title="Workshop Speakers"
        subtitle="Listen to all of our workshop speakers."
    >
        <SoundCloudPlayer url="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2056588857%3Fsecret_token%3Ds-U3xLaJffHHb&color=%23ff5500&auto_play=false&hide_related=false&show_comments=FALSE&show_user=false&show_reposts=false&show_teaser=true&visual=false" />
    </PageLayout>
);

const Contact = () => (
    <PageLayout
        title="Contact an AA member"
        subtitle="If you think you may be an alcoholic, and would like to talk to
                a sober AA member, please fill out the form below and someone
                will contact you shortly."
    >
        <SanitizedForm />
    </PageLayout>
);

async function hashPassword(password: string) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    console.log(hashBuffer);
    return [...new Uint8Array(hashBuffer)]
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}

const PasswordGate: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [input, setInput] = useState("");

    const storedHash =
        "623210167553939c87ed8c5f2bfe0b3e0684e12c3a3dd2513613c4e67263b5a1"; // from Node.js hash

    useEffect(() => {
        const saved = sessionStorage.getItem("speaker_auth");
        if (saved === "true") {
            setAuthenticated(true);
        }
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const inputHash = await hashPassword(input);
        if (inputHash === storedHash) {
            sessionStorage.setItem("speaker_auth", "true");
            setAuthenticated(true);
        } else {
            alert("Incorrect Password! Here's a hint: AA #1");
            setInput("");
        }
    };

    if (!authenticated) {
        return (
            <div
                style={{ padding: "2rem", margin: "10%", textAlign: "center" }}
            >
                <h2>Enter Password to Access Speakers</h2>
                <form
                    onSubmit={handleSubmit}
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <input
                        type="password"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Password"
                        style={{ marginRight: "1rem", padding: "0.5rem" }}
                    />
                    <button type="submit" style={{ padding: "0.5rem 1rem" }}>
                        Unlock
                    </button>
                </form>
            </div>
        );
    }

    return <>{children}</>;
};

const App: React.FC = () => {
    return (
        <Router>
            <div className="App">
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/events" element={<Events />} />
                    <Route
                        path="/speakers"
                        element={
                            <PasswordGate>
                                <Speakers />
                            </PasswordGate>
                        }
                    />
                    <Route
                        path="/search"
                        element={
                            <PasswordGate>
                                <PageLayout
                                    title={"Search Speakers"}
                                    subtitle={
                                        "Type below to find a specific speaker you would like to listen to"
                                    }
                                >
                                    <SpeakerSearch />
                                </PageLayout>
                            </PasswordGate>
                        }
                    />
                    <Route
                        path="/workshop"
                        element={
                            <PasswordGate>
                                <SpeakersWorkshop />
                            </PasswordGate>
                        }
                    />
                    <Route
                        path="/archived"
                        element={
                            <PasswordGate>
                                <SpeakersArchived />
                            </PasswordGate>
                        }
                    />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
};

export default App;
